var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationIconVisualExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-visual-explorer-01 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3,16H6a4,4,0,0,1-4-4V6A4,4,0,0,1,6,2h6a4,4,0,0,1,4,4v.79",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.45,10c3.32,3.39,3.87,8.33,1.23,11-3,3.07-4.22-1.26-5.86-1.4S12,21.88,9.9,19.73C6.58,16.34,6,11.4,8.67,8.71S16.13,6.57,19.45,10Z",
    fill: "none",
    stroke: "#343434",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.68,
    cy: 15.73,
    rx: 1.33,
    ry: 1.71,
    transform: "translate(-7.57 12.1) rotate(-42.73)",
    fill: "none",
    stroke: "#343434",
    strokeMiterlimit: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8,
    cy: 10.62,
    rx: 1.13,
    ry: 1.15,
    fill: "#343434",
    stroke: "#343434",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 12.93,
    rx: 1.13,
    ry: 1.15,
    fill: "#343434",
    stroke: "#343434",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.46,
    cy: 17.34,
    rx: 1.46,
    ry: 1.34,
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconVisualExplorer);
export default __webpack_public_path__ + "static/media/navigation-icon-visual-explorer.8f56b168c3a5472e90d5da215b67e977.svg";
export { ForwardRef as ReactComponent };